
import React from 'react';
import { FacilityOrderNewFlowInventoryCalculationProcessModalTemplate } from 'themes/application/facility-order-new-flow-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowInventoryCalculationProcessModalStore } from 'application/facility-order-new-flow-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowInventoryCalculationProcessModalStore(rootStore, componentProps), 'facilityOrderNewFlowInventoryCalculationProcessModalStore')
@observer
class FacilityOrderNewFlowInventoryCalculationProcessModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowInventoryCalculationProcessModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowInventoryCalculationProcessModal;
